export function parseJwt(token) {
  try {
    const base64 = token.split(".")[1];
    const json = atob(base64.replace(/-/g, "+").replace(/_/g, "/"));
    return JSON.parse(decodeURIComponent(escape(json)));
  } catch {
    return null;
  }
}

export function getTokenExp(token) {
  const payload = parseJwt(token);
  return payload?.exp ? payload.exp * 1000 : null; // ms
}
